// extracted by mini-css-extract-plugin
export default {"donate":"donate_donate__5OQ9s","para":"donate_para__phq4S"};